let cashierApi;
let wrapperPromiseResolve;
let widgetPromiseResolve;

const apiPromise = new Promise(resolve => {
  wrapperPromiseResolve = resolve;
});

const widgetPromise = new Promise(resolve => {
  widgetPromiseResolve = resolve;
});

export function setCashierApi(api) {
  cashierApi = api;
  wrapperPromiseResolve();
}

export function setWidgetLoaded() {
  widgetPromiseResolve();
}

export function getCashierApi() {
  return apiPromise.then(() => widgetPromise).then(() => cashierApi);
}
